
// Ajax cart JS for Drawer and Cart Page
const drawerSelectors = {
  cartIcons: document.querySelectorAll('.header__icon--cart'),
  cartIconDesktop: document.querySelector('#cart-icon-desktop'),
  cartIconMobile: document.querySelector('#cart-icon-mobile'),
};

class ajaxCart extends HTMLElement {
    constructor() {
      super();
  
      this.openeBy = drawerSelectors.cartIcons;
      this.isOpen =  this.classList.contains('open--drawer');
      this.bindEvents();
      
      this.setCookie();
      if(window.globalVariables.template != 'cart'){
        this.addAccessibilityAttributes(this.openeBy);
        this.getCartData();
      }else{
        this.style.visibility = 'visible';
      }
      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }
  
    /**
     * Observe attribute of component
     * 
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
      return ['updating'];
    }
  
    /**
     * To Perform operation when attribute is changed
     * Calls attributeChangedCallback() with params when attribute value is updated
     * 
     * @param {string} name attribute name
     * @param {string} oldValue attribute Old value
     * @param {string} newValue attribute latest value
     */
    attributeChangedCallback(name, oldValue, newValue) {
      // called when one of attributes listed above is modified
      if(name == 'updating' && newValue == 'false'){
        this.updateEvents();
      }
    }
  
    /**
     * Add accessibility attributes to Open Drawer buttons
     * 
     * @param {Node Array} openDrawerButtons Cart Icons
     */
    addAccessibilityAttributes(openDrawerButtons) {
      let _this = this;
      openDrawerButtons.forEach(element => {
        element.setAttribute('role', 'button');
        element.setAttribute('aria-expanded', false);
        element.setAttribute('aria-controls', _this.id);
      });
    }
  
    /**
     * Escape Click event to close drawer when focused within Cart Drawer
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
      this.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }

    setCookie(){
      this.getCookie('battlbox_fraud');
      var status = '';
      if (document.cookie && document.cookie.indexOf('battlbox_fraud') != -1) {
        status = 'Cookie is present';
      } else {
        status = 'Cookie is NOT present. It may be expired, or never set';
        this.createCookie('battlbox_fraud', 'true', 5);
      }
    }

    createCookie(name, value, minutes) {
      var date, expires;
      if (minutes) {
        date = new Date();
        date.setTime(date.getTime()+(minutes*60*1000));
        expires = "; expires="+date.toUTCString();
      } else {
        expires = "";
      }
      document.cookie = name+"="+value+expires+"; path=/";
    }

    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      var status = '';
      if (document.cookie && document.cookie.indexOf('battlbox_fraud') != -1) {
        status = 'Cookie is present';
      } else {
        status = 'Cookie is NOT present. It may be expired, or never set';
      }
      if (status != 'Cookie is present') {
        if(window.globalVariables.template == 'cart'){
          this.fraudDetect();
        }
      }
      return "";
    }

    /**
     * Detect fraud:  
     * Disable checkout button and show the snotify messages when:
     * vm.probability = 1
     * automationTool.probability = 1
     * browserSpoofing.probability = 1
     * searchEngine.probability = 1
    */

      fraudDetect() {
        var requestId;
        const APIHeaderN = {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Shop': 'battlboxllc.myshopify.com',
        };
        // Initialize an agent at application startup.
        const botdPromise = import('https://openfpcdn.io/botd/v0.1')
          .then( Botd => Botd.load({ publicKey: '3Hjazj3ouhErMIzokDYAMnS0' }))
          // Get the bot detection result when you need it.
          // Result will contain the `requestId` property, that you can securely verify on the server.
          botdPromise
          .then(botd => botd.detect())
          .then(function(result) { //We will have requestId here in result, and we will have to make API call to API Manager with this requestId and if we receive possibility as 1 for any of these four (https://d.pr/i/iq4mch) then we have to disable checkout & cart buttons. 
            requestId = result.requestId;
            const config = {
              url: '/verify',
              method: 'POST',
              data: {
                requestId: requestId,
              },
            };

            fetch('https://api-manager.praella.app/api/fingerprintjs/common', {
              method: 'POST',
              headers: APIHeaderN,
              body: JSON.stringify(config),
            })
            .then(response => response.json())
            .then(data => {
              if (data.vm.probability == 1 || data.bot.automationTool.probability == 1 || data.bot.browserSpoofing.probability == 1 || data.bot.searchEngine.probability == 1) {
                document.querySelector('[data-redirect_checkout]').setAttribute('disabled', true);
                document.querySelector('[data-redirect_checkout]').classList.add('btn-disabled');
                document.querySelector('#additional-checkout').classList.add('d-none');
                notificationEle.updateNotification('Error', 'There seems to be an issue with your browser. Please contact out customer support at questions@battlbox.com', {
                  type: 'error',
                  timeout: 3000
                });
              } 
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          })
        .catch(error => console.error(error))
      } 

    /**
     * bind click and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     * bind redirect to checkout events
     */
    bindEvents() {
      if(window.globalVariables.template != 'cart'){
        this.openeBy.forEach(cartBtn => cartBtn.addEventListener('click', this.openCartDrawer.bind(this)));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
      }
      this.form = this.querySelector('[data-redirect_checkout]');
      if (this.form) {
        this.form.addEventListener('click', this.getCartItems.bind(this));
      }
      this.updateEvents();
      if (document.querySelector('#additional-checkout')) {
        this.expressCheckout();
      }
    }

    /**
     * Get Cart Items
     * Check if subscriptions product then redirect to recharge checkout
     * Otherwise redirect to shopify checkout
     */

     getCartItems() {
      var isCheckOutURl = false;
      var cart = window.globalVariables.cart;
      var total_price = document.querySelector('[data-total-price]').getAttribute('data-total-price');
      var contents = [];

      cart.forEach((i) => {        
        contents.push({
          content_id: i.product_id,
          content_name: i.title,
          price: (i.price)/100,
          quantity: i.quantity
        })
      })
      var event_id = 'InitiateCheckout' + cart[0].key;
      this._checkoutEventTikTok(contents, event_id, 'product_group', window.theme.currency);
      tiktok._tikTokCheckout(contents, window.location.href, event_id);

      if (cart.find((x) => x.properties == null) || cart.find((x) => x.properties == undefined) || cart.find((x) => x.properties == null)) {} else {
        if (cart.find((x) => x.properties.shipping_interval_unit_type != null) || cart.find((x) => x.properties.shipping_interval_unit_type != undefined) || cart.find((x) => x.properties.type == 'gift-recharge-immediately') || cart.find((x) => x.properties.type == 'gift-recharge-email') || cart.find((x) => x.product_type == 'subscription')) {
          isCheckOutURl = true;
        } else {
          isCheckOutURl = false;
        }
      }

      // if (isCheckOutURl) {
      //   this._redirectToCheckout();
      // } else {
        window.location.href = '/checkout';
      // }
    }

     /**
     * Redirect to recharge checkout:
     */
    _redirectToCheckout = () => {
      function reChargeGetCookie(name) {
        return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2];
      }
      // Build the Checkout URL
      let ga_linker = '';
      const myshopify_domain = 'battlboxllc.myshopify.com';
      const token = reChargeGetCookie('cart');
      try {
        // Cross-domain tracking with Google Analytics
        ga_linker = ga.getAll()[0].get('linkerParam');
      } catch (e) {
        // 'ga' is not available
        ga_linker = '';
      }
      // Customer email address for use in the Checkout URL
      const customer_param = `customer_id=${window.theme.customersID}&customer_email=${window.theme.emailHashed}`;
      const checkout_url = `https://checkout.battlbox.com/r/checkout?myshopify_domain=${myshopify_domain}&cart_token=${token}&${ga_linker}&${customer_param}`;
      window.location.href = checkout_url;
    
      const xhr = new XMLHttpRequest();
      const data = {};
      xhr.open('POST', '/cart/update.js');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
        if (xhr.status === 200) {
          window.console.log('done', JSON.parse(xhr.responseText));
        } else if (xhr.status !== 200) {
          window.console.log('fail', JSON.parse(xhr.responseText));
        }
        const form = buildForm(data, checkout_url);
        document.body.appendChild(form);
        form.submit();
        };
      xhr.send(JSON.stringify(data));
    
    
      function buildInputs(form, obj) {
        // Build input fields for key, value pairs
        Object.keys(obj).forEach((key) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', key);
        input.setAttribute('value', typeof (obj[key]) === 'object' ? JSON.stringify(obj[key]) : obj[key]);
        form.appendChild(input);
        });
        }
        function buildForm(data, url) {
        // Build a virtual form
        const form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', url);
        form.setAttribute('id', 'rc_form');
        form.style.display = 'none';
        buildInputs(form, data);
        return form;
        }
    };

    /* InitiateCheckout Tiktok-Twitter Event */
      _checkoutEventTikTok(viewContent, event_id, content_type, currency){
        ttq.track('InitiateCheckout', {
          viewContent,
          event_id: event_id,
          content_type: content_type,
          value: window.globalVariables.total_price/100,
          currency: currency,
        });
        pintrk('track', 'custom');
      }

    /**
     * bind Other inside element events to DOM
     *
     */
    updateEvents(){
      this.querySelectorAll('.close-ajax--cart').forEach(button => button.addEventListener('click', this.closeCartDrawer.bind(this)));
      this.querySelectorAll('[data-itemRemove]').forEach(button => button.addEventListener('click', this.removItem.bind(this)));
      this.querySelectorAll('[data-qty-btn]').forEach(button => button.addEventListener('click', this.manageQtyBtn.bind(this)));
      this.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('change', this.onQtyChange.bind(this)));
    }
  
    /**
     * Hide express checkout if cart has subscription products otherwise show the express checkout
     *
     */
    expressCheckout(){
      if (document.querySelector('#additional-checkout')) {
        var isExpressCheckout = false;
        var cart = window.globalVariables.cart;

        if (cart.find((x) => x.properties == null) || cart.find((x) => x.properties == undefined) || cart.find((x) => x.properties == null)) {

        } else {
          if (cart.find((x) => x.properties.shipping_interval_unit_type != null) || cart.find((x) => x.properties.shipping_interval_unit_type != undefined) || cart.find((x) => x.properties.type == 'gift-recharge-immediately') || cart.find((x) => x.properties.type == 'gift-recharge-email') || cart.find((x) => x.product_type == 'subscription')) {
            isExpressCheckout = true;
          } else {
            isExpressCheckout = false;
          }
        }
        if (isExpressCheckout) {
          document.querySelector('#additional-checkout').classList.add('d-none');
        } else {
          document.querySelector('#additional-checkout').classList.remove('d-none');
        }
      }
    }


    /**
     * Open Cart drawer and add focus to drawer container
     *
     * @param {event} Event instance
     */
    openCartDrawer(event) {
      if(!window.globalVariables.cart_drawer){
        window.location.href = window.routes.cart_fetch_url || '/cart';
        return;
      }
  
      if(document.querySelector('#mobile-menu-drawer').classList.contains('opened-drawer')){
        document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
      }
  
      this.classList.add('opened-drawer');
      document.querySelector('body').classList.add('menu-opened');
      siteOverlay.prototype.showOverlay();
      Utility.forceFocus(this.querySelector('.cart-title'));
      let closeBtn = this.querySelector('.close-ajax--cart');
      Utility.trapFocus(this, closeBtn);
  
      if(event){
        event.preventDefault();
        let openBy = event.currentTarget;
        openBy.setAttribute('aria-expanded', true);
      }
    }
  
    /**
     * Close Cart drawer and Remove focus from drawer container
     *
     * @param {event} Event instance
     */
    closeCartDrawer(event, elementToFocus = false) {
      if (event !== undefined) {
        event.preventDefault();
        this.classList.remove('opened-drawer');
        siteOverlay.prototype.hideOverlay();
        document.querySelector('body').classList.remove('menu-opened');
        let openByEle = event.currentTarget;
        openByEle.setAttribute('aria-expanded', false);
        Utility.removeTrapFocus(elementToFocus);
  
        let actionBtn = drawerSelectors.cartIconDesktop;
        if(window.innerWidth < 1024){
          actionBtn = drawerSelectors.cartIconMobile;
        }
        Utility.forceFocus(actionBtn);
      }
    }
  
    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {string} action Open Drawer as value if need to Open Cart drawer
     */
    _updateCart(response, action){
      
      this.setAttribute('updating', true);

      // Convert the HTML string into a document object
      let cartHTML = '';
      if(window.globalVariables.template != 'cart') {
        cartHTML = response['template-ajax-cart'];
      }else{
        cartHTML = response['template-cart'];
      }
      

      if(cartHTML == null) return;
      let parser = new DOMParser();
      cartHTML = parser.parseFromString(cartHTML, 'text/html');

      const cartJSON = JSON.parse(cartHTML.querySelector('[data-cartJSON]').textContent);
      window.globalVariables.cart = cartJSON.items;

      let cartElement = cartHTML.querySelector('ajax-cart');
      if(window.globalVariables.template != 'cart') {
        this.innerHTML = cartElement.innerHTML; 
      } else {
        if(cartJSON.items.length > 0){
          this.querySelector('[data-empty-cart]').classList.add('d-none');
          this.querySelectorAll('[data-has-cart]').forEach(ele => ele.classList.remove('d-none'));
          this.querySelector('[data-cart-items]').innerHTML = cartElement.querySelector('[data-cart-items]').innerHTML;
          this.querySelector('[data-total-price]').innerHTML = cartElement.querySelector('[data-total-price]').innerHTML; 
        } else {
          // this.innerHTML = cartElement.innerHTML;
          this.querySelectorAll('[data-has-cart]').forEach(ele => ele.classList.add('d-none'));
          this.querySelector('[data-empty-cart]').classList.remove('d-none');
        }
      }

      this.setAttribute('updating', false);
      
      
      
      // if(window.globalVariables.template != 'cart'){
      //   let upsellModal = document.querySelector('#cartUpsellModal');
      //   if(upsellModal){
      //     let upsellModalOpen = upsellModal.querySelector('.modal').classList.contains('open');
      //     if(typeof cartUpsellJS == 'function' && (action == 'open_upsell' || upsellModalOpen)) cartUpsellJS.prototype.upsellProduct(window.globalVariables.cart);
      //   }
      // }else{
      //   if(typeof cartUpsellJS == 'function') cartUpsellJS.prototype.hideUpsellProduct(window.globalVariables.cart);
      // }
      let hasBattvault = false;
      window.globalVariables.cart.forEach(ele => {
        if(ele.properties != null){
          if(ele.properties['battlvault_product']){
            hasBattvault = true;
            return false;
          }
        }
      });

      let customerAlig = false;
      if(window.theme.customersEmail == '') {
        customerAlig = true;
      } else {
        if(window.theme.customerTags != null && window.theme.customerTags.length > 0){
          let hasT = window.theme.customerTags.find((x) => x == 'Inactive Subscriber');
          if (hasT != undefined) customerAlig = true;
        }
      }

      if(hasBattvault && customerAlig){
        let itemsR = {};
        window.globalVariables.cart.forEach((ele,i) => {
          if(ele.properties != null){
            if(ele.properties['battlvault_product']){
              itemsR[ele.id] = 0;
            }
          }
        });
        const body = JSON.stringify({updates: itemsR});
  
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.json;
        })
        .then((state) => {
          this.getCartData();
        }).catch((error) => {
          console.log(error);
        });
      } else {
        let headerHTML = new DOMParser().parseFromString(response['header'], 'text/html');
        let cartIcon = headerHTML.getElementById('cart-icon-desktop');
        if(drawerSelectors.cartIconDesktop) drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
        if(drawerSelectors.cartIconMobile) drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;
        
        if(window.globalVariables.cart_drawer == true && action == 'open_drawer' && window.globalVariables.template != 'cart'){
          this.openCartDrawer();
        }
        this.form = this.querySelector('[data-redirect_checkout]');
        if (this.form) {
          this.form.addEventListener('click', this.getCartItems.bind(this));
        }
      }

    }

    /**
     * Fetch latest cart data 
     *
     * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
     */
    getCartData(action){
        let fetchCart = fetch(`${routes.cart_fetch_url}?sections=template-cart,header`);
        if(window.globalVariables.template != 'cart') fetchCart = fetch(`${routes.cart_fetch_url}?sections=template-ajax-cart,header`);
        fetchCart.then(response => {
          return response.json();
        }).then(response => {
            this._updateCart(response, action);
        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            // Cart HTML fetch done
        });
    }
  
     /**
     * Update Quantity API call 
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     */
    updateItemQty(line, quantity){
        let lineItem = document.querySelectorAll('[data-cart-item]')[line-1];

        if(lineItem){ lineItem.classList.add('updating'); }
        const body = JSON.stringify({
            line,
            quantity
        });
  
        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }})
        .then((response) => {
            fetch('/cart.json', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(data => {
              let res = data.json();
              res.then((result) => {
                document.querySelector('[data-item_count]').innerHTML = result.items.length;
              });
            })
            return response.text();
        })
        .then((state) => {
          this.getCartData();
          setTimeout(() => {
            if(lineItem){ lineItem.classList.remove('updating'); }
          }, 1000);
        }).catch((error) => {
          setTimeout(() => {
            if(lineItem){ lineItem.classList.remove('updating'); }
          }, 1000);
          console.log(error);
        });
    }
  
    /**
     * Remove Item Event
     *
     * @param {event} Event instance
     */
    removItem(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let itemIndex = currentTarget.dataset.index || null;
      let pTitle = currentTarget.dataset.producttitle;
      let pId = currentTarget.dataset.itemId;
      let vId = currentTarget.dataset.itemVId;
      let vendor = currentTarget.dataset.vendor;
      let price = currentTarget.dataset.price;

      if(itemIndex != null){
          this.updateItemQty(itemIndex, 0);
          dataLayer.push({ ecommerce: null });  
          dataLayer.push({
            event: "remove_from_cart",
            ecommerce: {
              currency: window.theme.currency,
              value: `${ window.globalVariables.cart.total_price / 100.0 }`,
              items: [
                {
                  item_id: pId,
                  item_name: pTitle,
                  affiliation: "Google Merchandise Store",
                  index: itemIndex,
                  item_brand: vendor,
                  item_variant: vId,
                  price: price,
                  quantity: 0
                }
              ]
            }
          });
      }
    }
  
    /**
     * Cart Item Qunatity Increment/Decrement Button event
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      let itemIndex = $qtyInput.dataset.index || 1;
      let currentQty = parseInt($qtyInput.value) || 1;
      let finalQty = 1;
  
      if(action == 'decrease' && currentQty <= 1){
          return false;
      }else if(action == 'decrease'){
          finalQty = currentQty - 1;
      }else{
          finalQty = currentQty + 1;
      }
      this.updateItemQty(itemIndex, finalQty);
    }

    /**
     * Cart Item Qunatity Input change event
     *
     * @param {event} Event instance
     */
    onQtyChange(event){
      const $qtyInput = event.currentTarget;
      const qtyValue = $qtyInput.value;
      const itemIndex = $qtyInput.dataset.index || null;
      if(itemIndex) this.updateItemQty(itemIndex, qtyValue);
    }
  
}
customElements.define("ajax-cart", ajaxCart);
  
